import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Button from 'components/elements/buttons/Button';
import CommonModal from 'components/elements/modals/CommonModal';
import SocialNetworkRequestForm
  from 'components/dashboard/social-content/SocialNetworkRequestForm';
import CommonMessage from 'components/common/CommonMessage';

import img from 'components/dashboard/earn-content/EarnSwitcher/ReviewModal/images/ic_paper-airplane.svg';

import './SocialNetworkRequestModal.css';

const SocialNetworkRequestModal = props => {
  const {
    open,
    onClose,
    createSocialLinkRequestStatusSuccess,
    createSocialLinkRequestStatusError,
    type,
  } = props;
  const { t } = useTranslation();

  return (
    <CommonModal
      className="social-network-request-modal__component"
      open={open}
      onClose={onClose}
    >
      {createSocialLinkRequestStatusSuccess && !createSocialLinkRequestStatusError &&
        <div className="wrapper">
          <div className="text-content">
            <img src={img} alt="" />
            <b>
              {t("We received your request.")}<br />
              {t("We will add suggested item in the coming weeks if the request is valid.")}
            </b>
          </div>
          <div className="buttons-block">
            <Button
              className="modal-button confirm"
              onClick={onClose}
            >
              {t("Ok, sounds good!")}
            </Button>
          </div>
        </div>
      }

      {/* Request Form */}
      {!createSocialLinkRequestStatusSuccess && !createSocialLinkRequestStatusError &&
        <SocialNetworkRequestForm type={type} />
      }

      {/* Error */}
      {createSocialLinkRequestStatusError &&
        createSocialLinkRequestStatusError.error &&
        <div className="wrapper">
          <CommonMessage
            warning
            content={createSocialLinkRequestStatusError.error}
          />
          <div className="buttons-block">
            <Button
              className="modal-button confirm"
              onClick={onClose}
            >
              {t("Back to the list")}
            </Button>
          </div>
        </div>
      }
    </CommonModal>
  );
};

SocialNetworkRequestModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  createSocialLinkRequestStatusSuccess: PropTypes.object,
  createSocialLinkRequestStatusError: PropTypes.object,
  type: PropTypes.string.isRequired,
};

SocialNetworkRequestModal.defaultProps = {
  open: false,
  onClose: null,
  createSocialLinkRequestStatusSuccess: null,
  createSocialLinkRequestStatusError: null,
};

const mapStateToProps = state => (
  {
    createSocialLinkRequestStatusSuccess: state.linksReducer.createSocialLinkRequestStatusSuccess,
    createSocialLinkRequestStatusError: state.linksReducer.createSocialLinkRequestStatusError,
  }
);

export default connect(
  mapStateToProps,
  {},
)(SocialNetworkRequestModal);
